var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { appear: "", name: "c-modal-fade" } }, [
    _vm.isOpened
      ? _c(
          "div",
          { class: ["c-modal", { "-open": _vm.isOpened }] },
          [
            !_vm.noOverlay
              ? _c("overlay", {
                  key: "overlay",
                  attrs: { show: "" },
                  on: { close: _vm.emit }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { key: "c-modal", class: _vm.classes }, [
              _c("div", { staticClass: "modal" }, [
                _c("div", { staticClass: "header" }, [
                  _c("div", { staticClass: "title" }, [
                    _c("h1", [_vm._v("title")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "actions" }, [
                    _c(
                      "button",
                      {
                        attrs: { disabled: _vm.disabled },
                        on: {
                          click: function($event) {
                            return _vm.$emit("close")
                          }
                        }
                      },
                      [_vm._v("X")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [_vm._t("default")], 2)
              ])
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }